<template>
  <div v-if="participant.statusIsLoaded" class="mx-3">
    <section>
      <!-- If the DAYS are up to date, then user is not in the middle of entering details about angina. OK to trash him if he is doing the WINDOWS, or if he is fully up to date and the app is at rest -->
      <AppAutoupdate :canUpdateNow="true"></AppAutoupdate>
    </section>

    <transition name="slide-fade">
      <div v-if="entryMode === 'practice'">
        <div v-if="date.targetKey === date.dayBeforeYesterdayKey">
          <div class="alert alert-primary" style="margin-bottom: 0">
            <h3>Welcome to the ORBITA-2 symptom app</h3>
            <h4>
              To practice, imagine there is a patient called Bob. Read Bob’s
              story and answer below as if you were Bob.
            </h4>
            <hr />
            <h4>
              The day before yesterday, Bob had angina
              <strong>twice</strong>: once <strong>mild</strong> and once
              <strong>moderate</strong>.
            </h4>
          </div>
        </div>

        <div v-if="date.targetKey === date.yesterdayKey">
          <div class="alert alert-primary" style="margin-bottom: 0">
            <h3>Practice, Part 2</h3>
            <hr />
            <h4>
              <strong>Yesterday,</strong> Bob had no angina. <br />Answer for
              Bob below.
            </h4>
          </div>
        </div>

        <div
          v-if="
            symptomEntryProgress.upToDate.days &&
            !symptomEntryProgress.upToDate.windows
          "
        >
          <div class="alert alert-primary" style="margin-bottom: 0">
            <h3>Practice, Part 3</h3>
            <hr />
            <h4>
              Bob says, “In the last couple of days, I've noticed I get angina
              when I
              <strong>{{
                participant.contactObj.windows.questions.activity_002
              }}</strong
              >, but not when I
              <strong>{{
                participant.contactObj.windows.questions.activity_001
              }}</strong
              >. ”
            </h4>
          </div>
        </div>
      </div>
    </transition>

    <div v-if="symptomEntryProgress.theresMore">
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <div style="display: flex; flex-direction: row; justify-content: center">
        <SpinnerTrinity></SpinnerTrinity>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
    <div v-else>
      <!-- NOT theresMore ---------------------------------- -->

      <div v-if="symptomEntryProgress.upToDate.all">
        <transition name="slide-fade">
          <div>
            <br />
            <div class="alert alert-success">
              <h2>Thank you!</h2>
              <hr />
              <h4 v-if="entryMode === 'practice'">
                Bob is up to date. His next entry would be tomorrow.
              </h4>
              <h4 v-else>
                You are up to date. Your next entry will be tomorrow.
              </h4>
              <br />
              <h4 v-if="entryMode !== 'practice'">
                Once a week you will also be asked whether you get angina when
                you
                {{
                  participant.contactObj.windows.questions.activity_001 ||
                  "** SOME IMPORTANT INFORMATION IS MISSING. PLEASE CONTACT THE ORBITA TEAM AND ASK THEM TO 'SET UP YOUR WEEKLY ACTIVITY DESCRIPTION' **"
                }}, and when you
                {{
                  participant.contactObj.windows.questions.activity_002 ||
                  "** SOME IMPORTANT INFORMATION IS MISSING. PLEASE CONTACT THE ORBITA TEAM AND ASK THEM TO 'SET UP YOUR WEEKLY ACTIVITY DESCRIPTION' **"
                }}.
              </h4>
              <br />
              <p v-if="entryMode === 'live'">
                All data are saved. App can be closed.
              </p>
            </div>
          </div>
        </transition>

        <div v-if="entryMode === 'practice'">
          <div class="alert alert-primary" style="margin-bottom: 0">
            <h4>Well done!</h4>
            <hr />
            <h5>
              You have succeeded in the practice. From now on, use this App
              daily to report
              <em>your own</em> angina from
              <em>the day before</em>
              . "Angina" means the symptom that made you go to your doctor: "{{
                participant.contactObj.myAnginaIs
              }}". There will be a Help button to remind you of this.
            </h5>

            <h5>Ready to use the App?</h5>

            <div
              style="
                display: flex;
                flex-direction: row;
                justify-content: space-evenly;
              "
            >
              <b-button
                size="lg"
                variant="primary"
                v-on:click="
                  writeAndLog(
                    participant.statusRef.child('trained'),
                    true,
                    true
                  )
                "
                >Yes</b-button
              >
              <b-button
                size="lg"
                variant="secondary"
                v-on:click="
                  writeAndLog(
                    participant.statusRef.child(liveOrPractice),
                    null
                  );
                  startSymptomEntryComponentAfresh();
                "
              >
                No, practice again
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="!symptomEntryProgress.upToDate.all"
        id="questions-block"
        class="progress-container"
      >
        <div
          v-if="!symptomEntryProgress.upToDate.days"
          id="questions-block-for-day"
        >
          <h2>{{ date.targetDisplayStringWithComment }}</h2>

          <div
            v-if="
              !participant.statusObj[liveOrPractice] ||
              !participant.statusObj[liveOrPractice].days ||
              !participant.statusObj[liveOrPractice].days[date.targetKey] ||
              !participant.statusObj[liveOrPractice].days[date.targetKey].saved
            "
          >
            <hr />
            <transition name="slide-fade" mode="out-in">
              <div
                v-if="
                  !(
                    participant.statusObj[liveOrPractice] &&
                    participant.statusObj[liveOrPractice].days &&
                    participant.statusObj[liveOrPractice].days[
                      date.targetKey
                    ] &&
                    participant.statusObj[liveOrPractice].days[date.targetKey]
                      .anginaYesNo
                  )
                "
              >
                <h2>
                  Did {{ entryMode === "practice" ? "Bob" : "you" }} have any
                  angina?
                </h2>

                <ErrorPracticeWrongAnswer
                  v-if="errorWrongPracticeAnswer"
                ></ErrorPracticeWrongAnswer>

                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    justify-content: space-evenly;
                  "
                >
                  <b-button
                    size="lg"
                    variant="primary"
                    v-on:click="
                      checkAndWriteAnswerToDailyAnginaYesNoQuestion('Yes')
                    "
                    >&nbsp; &nbsp; Yes &nbsp; &nbsp;</b-button
                  >&nbsp;
                  <b-button
                    size="lg"
                    variant="primary"
                    v-on:click="
                      checkAndWriteAnswerToDailyAnginaYesNoQuestion(
                        'No' /* includes built-in writing to '.saved', and the TRUE option to recalc */
                      )
                    "
                    >&nbsp; &nbsp; No &nbsp; &nbsp;</b-button
                  >
                </div>

                <br />
              </div>
            </transition>

            <div
              v-if="
                participant.statusObj[liveOrPractice] &&
                participant.statusObj[liveOrPractice].days &&
                participant.statusObj[liveOrPractice].days[date.targetKey] &&
                participant.statusObj[liveOrPractice].days[date.targetKey]
                  .anginaYesNo === 'No'
              "
            >
              <h5>
                No angina &nbsp;
                <button
                  type=" button"
                  class="btn btn-outline-secondary btn-sm"
                  v-on:click="
                    writeAndLog(
                      participant.statusRef
                        .child(liveOrPractice)
                        .child('days')
                        .child(date.targetKey)
                        .child('anginaYesNo'),
                      null
                    )
                  "
                >
                  Edit
                </button>
              </h5>
            </div>

            <transition name="slide-fade" mode="out-in">
              <div
                v-if="
                  participant.statusObj[liveOrPractice] &&
                  participant.statusObj[liveOrPractice].days &&
                  participant.statusObj[liveOrPractice].days[date.targetKey] &&
                  participant.statusObj[liveOrPractice].days[date.targetKey]
                    .anginaYesNo === 'Yes'
                "
              >
                <h5
                  v-if="
                    !participant.statusObj[liveOrPractice].days[date.targetKey]
                      .anginaCount
                  "
                >
                  Angina &nbsp;
                  <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm"
                    v-on:click="
                      writeAndLog(
                        participant.statusRef
                          .child(liveOrPractice)
                          .child('days')
                          .child(date.targetKey)
                          .child('anginaYesNo'),
                        null
                      )
                    "
                  >
                    Edit
                  </button>
                </h5>

                <h5
                  v-if="
                    participant.statusObj[liveOrPractice].days[date.targetKey]
                      .anginaCount
                  "
                >
                  {{
                    participant.statusObj[liveOrPractice].days[date.targetKey]
                      .anginaCount
                  }}
                  episode{{
                    parseInt(
                      participant.statusObj[liveOrPractice].days[date.targetKey]
                        .anginaCount
                    ) >= 2
                      ? "s"
                      : ""
                  }}
                  of angina
                  <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm"
                    v-on:click="
                      writeAndLog(
                        participant.statusRef
                          .child(liveOrPractice)
                          .child('days')
                          .child(date.targetKey)
                          .child('anginaYesNo'),
                        null
                      );
                      writeAndLog(
                        participant.statusRef
                          .child(liveOrPractice)
                          .child('days')
                          .child(date.targetKey)
                          .child('anginaCount'),
                        null
                      );
                    "
                  >
                    Edit
                  </button>
                </h5>

                <transition name="slide-fade" mode="out-in">
                  <div
                    v-if="
                      participant.statusObj[liveOrPractice] &&
                      participant.statusObj[liveOrPractice].days &&
                      participant.statusObj[liveOrPractice].days[
                        date.targetKey
                      ] &&
                      participant.statusObj[liveOrPractice].days[date.targetKey]
                        .anginaCount === undefined
                    "
                  >
                    <br />
                    <h2>
                      How many times did
                      {{ entryMode === "practice" ? "Bob" : "you" }} have
                      angina?
                    </h2>

                    <ErrorPracticeWrongAnswer
                      v-if="errorWrongPracticeAnswer"
                    ></ErrorPracticeWrongAnswer>

                    <div
                      style="
                        max-width: 80vw;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: wrap;
                        padding: 1em;
                      "
                    >
                      <button
                        type="button"
                        class="btn btn-primary spaced-button"
                        v-on:click="
                          checkAndWriteAnswerToFrequencyQuestion(1);
                          resetSlider();
                        "
                      >
                        Once
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary spaced-button"
                        v-on:click="
                          checkAndWriteAnswerToFrequencyQuestion(2);
                          resetSlider();
                        "
                      >
                        Twice
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary spaced-button"
                        v-on:click="
                          checkAndWriteAnswerToFrequencyQuestion(3);
                          resetSlider();
                        "
                      >
                        3 times
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary spaced-button"
                        v-on:click="
                          checkAndWriteAnswerToFrequencyQuestion(4);
                          resetSlider();
                        "
                      >
                        4 times
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary spaced-button"
                        v-on:click="
                          checkAndWriteAnswerToFrequencyQuestion(5);
                          resetSlider();
                        "
                      >
                        5 times
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary spaced-button"
                        v-on:click="
                          checkAndWriteAnswerToFrequencyQuestion('6 or more');
                          resetSlider();
                        "
                      >
                        6 or more
                      </button>
                    </div>
                  </div>
                </transition>

                <transition name="slide-fade" mode="out-in">
                  <div
                    style="width: 100%"
                    v-if="
                      participant.statusObj[liveOrPractice] &&
                      participant.statusObj[liveOrPractice].days &&
                      participant.statusObj[liveOrPractice].days[
                        date.targetKey
                      ] &&
                      participant.statusObj[liveOrPractice].days[date.targetKey]
                        .anginaCount !== undefined &&
                      !validAnginaSeverity(
                        participant.statusObj[liveOrPractice].days[
                          date.targetKey
                        ].anginaSeverity
                      )
                    "
                  >
                    <h2>
                      How bad was
                      <span
                        v-if="
                          parseInt(
                            participant.statusObj[liveOrPractice].days[
                              date.targetKey
                            ].anginaCount
                          ) >= 2
                        "
                      >
                        the worst episode
                      </span>
                      <span v-else>it</span>? &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                      &nbsp; &nbsp; &nbsp; &nbsp;
                    </h2>

                    <div style="width: 100%">
                      <ErrorPracticeWrongAnswer
                        v-if="errorWrongPracticeAnswer"
                      ></ErrorPracticeWrongAnswer>
                      <br />

                      <div>
                        <div
                          style="
                            display: flex;
                            flex-direction: row;
                            text-align: center;
                            margin-left: 16px;
                            margin-right: 16px;
                            font-size: 71%;
                          "
                        >
                          <!-- https://www.tutorialrepublic.com/html-reference/html-color-picker.php -->
                          <div
                            style="
                              width: 33.333%;
                              overflow: hidden;
                              background-color: #e5eff7;
                            "
                          >
                            Mild
                          </div>
                          <div
                            style="
                              width: 33.333%;
                              overflow: hidden;
                              background-color: #ccdff0;
                            "
                          >
                            Moderate
                          </div>
                          <div
                            style="
                              width: 33.333%;
                              overflow: hidden;
                              background-color: #b2cfe9;
                            "
                          >
                            Severe
                          </div>
                        </div>

                        <div
                          class="d-flex flex-row"
                          style="margin-left: 12px; margin-right: 12px"
                        >
                          <div
                            :style="`width:${rangeLeftPc}%; height:1em;`"
                          ></div>
                          <div
                            v-if="sliderValue >= 1"
                            class="zero-width-arrow-up"
                          ></div>
                          <div
                            :style="`width:${rangeRightPc}%; height:1em;`"
                          ></div>
                        </div>

                        <div>
                          <b-form-input
                            type="range"
                            :min="1"
                            :max="600"
                            v-model="sliderValue"
                          ></b-form-input>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div style="text-align: right">
                      <b-button
                        :style="{
                          background: '#005eb9',
                          opacity: validAnginaSeverity(sliderValue) ? 1 : 0,
                        }"
                        size="lg"
                        v-on:click="
                          checkAndWriteAnswerToSeverityQuestion(sliderValue)
                        "
                        >&nbsp; &nbsp; OK &nbsp; &nbsp;</b-button
                      >
                    </div>
                  </div>
                </transition>
              </div>
            </transition>
          </div>
        </div>

        <div
          v-if="
            symptomEntryProgress.upToDate.days &&
            !symptomEntryProgress.upToDate.windows
          "
          id="questions-block-for-windows"
        >
          <h2>
            During the {{ (missingWindow || {}).durationDaysInclusive }} days
            from {{ (missingWindow || {}).startDateDisplay }} to
            {{ (missingWindow || {}).endDateDisplay }}:
          </h2>

          <div
            v-if="
              !participant.statusObj[liveOrPractice] ||
              !participant.statusObj[liveOrPractice].days ||
              !participant.statusObj[liveOrPractice].days[date.targetKey] ||
              !participant.statusObj[liveOrPractice].days[date.targetKey].saved
            "
          >
            <hr />

            <transition name="slide-fade" mode="out-in">
              <div>
                <h3>
                  {{
                    entryMode === "practice"
                      ? "We need to know from Bob, “When you"
                      : "When you"
                  }}
                  <strong>
                    {{
                      missingWindow &&
                      missingWindow.question &&
                      missingWindow.question.whenYou
                    }}
                  </strong>
                  , do you get angina?{{ entryMode === "practice" ? "”" : "" }}
                </h3>

                <ErrorPracticeWrongAnswer
                  v-if="errorWrongPracticeAnswer"
                ></ErrorPracticeWrongAnswer>

                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    justify-content: space-evenly;
                  "
                >
                  <b-button
                    size="lg"
                    variant="primary"
                    v-on:click="checkAndWriteAnswerToWindowQuestion('Yes')"
                    >&nbsp; &nbsp; Yes &nbsp; &nbsp;</b-button
                  >
                  <b-button
                    size="lg"
                    variant="primary"
                    v-on:click="checkAndWriteAnswerToWindowQuestion('No')"
                    >&nbsp; &nbsp; No &nbsp; &nbsp;</b-button
                  >
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable indent */
/* eslint-disable standard/computed-property-even-spacing */
import { DateTime } from "luxon";

import {
  auth,
  logRootRef,
  ServerValueTIMESTAMP,
  debugRootRef,
} from "../firebaseSetup.js";
import AppAutoupdate from "./AppAutoupdate.vue";
import ErrorPracticeWrongAnswer from "./ErrorPracticeWrongAnswer.vue";
import SpinnerTrinity from "./from_st_elsewhere/SpinnerTrinity.vue";
// https://www.sitepoint.com/use-html5-vibration-api/
navigator.vibrate =
  navigator.vibrate ||
  navigator.webkitVibrate ||
  navigator.mozVibrate ||
  navigator.msVibrate;
if (navigator.vibrate) {
  // vibration API supported
}

const platform = require("platform");

export default {
  components: {
    AppAutoupdate,
    SpinnerTrinity,
    ErrorPracticeWrongAnswer,
  },

  props: {
    // Received from parent. Do not mutate because if the parent changes a variable, it will re-render and lose your mutation.
    participant: {
      contactRef: {},
      contactObj: {},
      statusObj: {},
      statusIsLoaded: null,
    },
    entryMode: {
      type: String,
      required: true,
      validator: (value) => ["live", "practice"].includes(value),
    },
  },

  data: function () {
    // Local data that we need to trigger re-rendering.
    return {
      liveOrPractice: "",
      date: {
        // We will calculate missing missing day-by-day date and stick in here.
      },
      missingWindow: {
        // we will calculate the missing window and stick in here
      },

      symptomEntryProgress: {
        // Optional declaration of what's in it, for documentation purposes
        upToDate: {
          all: false,
          days: false,
          windows: false,
        },
        theresMore: false,
      },
      sliderInitialInvalidValue: 0, // this is like a CONST that the sliderValue is set to each time rather than being zeroed. It is in the acceptable range, to avoid an error by VueSlider component, but also a fraction, so we can recognise it as invalid and NOT show the OK button until the user jiggles it a bit
      sliderValue: 0,

      errorWrongPracticeAnswer: false,
    };
  },

  computed: {
    rangeMidPc() {
      return 0;
    },

    rangeLeftPc() {
      return (this.sliderValue / 600) * 100 - this.rangeMidPc / 2;
    },

    rangeRightPc() {
      return 100 - this.rangeMidPc - this.rangeLeftPc;
    },
  },

  created: function () {
    this.startSymptomEntryComponentAfresh();

    this.participant.statusRef.child("trained").on("value", () => {
      setTimeout(this.startSymptomEntryComponentAfresh, 10);
    }); // If the "isTrained" is changed

    this.participant.statusRef.child("refresh").on("value", (a) => {
      // This is superfluous on a local system but if logged in on two systems, or staff & patient logged on at two different places, looking at the same participant record, it ensures that when the date needs to be recalculated, it is done and screen updated.

      this.savedSoPleaseRecalculateMissingDaysAndWindows(
        false /* no spinner */
      );
    });
  },

  methods: {
    triggerParticipantScreenRefresh: function () {
      // DUPLICATED -- naughtily --- in RESVIEW
      // this is picked up by the firebase "ON" on the refresh node and triggers this.startSymptomEntryComponentAfresh() at the end of a setTimeout (to let the digest finish)
      this.participant.statusRef
        .child("refresh")
        .set(
          Math.random().toString(36).substring(2, 15) +
            Math.random().toString(36).substring(2, 15)
        );
    },

    validAnginaSeverity: function (severity) {
      const sev = parseFloat(severity);
      return (
        sev === parseInt(sev) &&
        sev >= 1 &&
        sev <= 600 &&
        sev !== this.sliderInitialInvalidValue
      );
    },

    resetSlider: function () {
      this.sliderValue = this.sliderInitialInvalidValue;
    },

    startSymptomEntryComponentAfresh: function () {
      // This makes it calculate when the component starts. The tag in the parent that calls the component has a v-if that only allows the component to be created when statusObj[liveOrPractice] is loaded by firebase. That is important otherwise the target date calculation will not see any data

      if (this.entryMode === "practice") {
        this.liveOrPractice = "practice";

        const recentDates = this.calcTodayYesterdayDayBeforeYesterdayKeys();

        Promise.all([
          this.writeAndLog(
            this.participant.statusRef
              .child("practice")
              .child("days")
              .child(recentDates.dayBeforeYesterdayKey),
            null
          ),
          this.writeAndLog(
            this.participant.statusRef
              .child("practice")
              .child("days")
              .child(recentDates.yesterdayKey),
            null
          ),
          this.writeAndLog(
            this.participant.statusRef.child("practice").child("windows"),
            null
          ),
        ]).then(() => {
          // Set up this component for practice
          const targetDateAndUpToDateness = this.calcTargetDateAndUpToDateness(
            recentDates.dayBeforeYesterdayKey,
            (this.participant.statusObj || {})[this.liveOrPractice],
            this.participant.contactObj || {}
          );
          this.symptomEntryProgress.upToDate =
            targetDateAndUpToDateness.upToDate;
          this.date = targetDateAndUpToDateness.date;
          this.missingWindow = targetDateAndUpToDateness.missingWindow;
        });
      } else {
        // Set up this component for live
        this.liveOrPractice = "live";

        const targetDateAndUpToDateness = this.calcTargetDateAndUpToDateness(
          this.participant.contactObj.startDateKey,
          (this.participant.statusObj || {})[this.liveOrPractice],
          this.participant.contactObj || {}
        );
        this.symptomEntryProgress.upToDate = targetDateAndUpToDateness.upToDate;
        this.date = targetDateAndUpToDateness.date;
        this.missingWindow = targetDateAndUpToDateness.missingWindow;
      }
    },

    startDateKeyLiveOrPractice() {
      return this.entryMode === "practice"
        ? this.calcTodayYesterdayDayBeforeYesterdayKeys().dayBeforeYesterdayKey
        : this.participant.contactObj.startDateKey || "2001-01-01";
    },

    calcTodayYesterdayDayBeforeYesterdayKeys(options = {}) {
      // options:
      //   debugLogIt: write to log or not

      let date = {};
      let debugItem = {};

      const spacesForVisibilityInFirebaseConsole = "     ⬛⬛"; // so can read in firebase console which truncates last bit

      debugItem["A"] =
        "PARTICIPANT " +
        this.participant.contactObj.shortName +
        " " +
        this.participant.contactObj.trialId +
        ", start date " +
        this.participant.contactObj.startDateKey +
        spacesForVisibilityInFirebaseConsole;

      debugItem["A1"] =
        platform.description + spacesForVisibilityInFirebaseConsole;

      debugItem["B"] =
        "Confirming that the KEYS are definitely correct" +
        spacesForVisibilityInFirebaseConsole;
      debugItem["B01"] =
        "new Date().toISOString() is " +
        new Date().toISOString() +
        spacesForVisibilityInFirebaseConsole;

      date.todayKey = new Date().toISOString().slice(0, 10);
      debugItem["B02"] =
        "date.todayKey set to " +
        date.todayKey +
        spacesForVisibilityInFirebaseConsole;

      date.yesterday = new Date();
      date.yesterday.setDate(date.yesterday.getDate() - 1);
      date.yesterdayKey = date.yesterday.toISOString().slice(0, 10);

      date.dayBeforeYesterday = new Date();
      date.dayBeforeYesterday.setDate(date.dayBeforeYesterday.getDate() - 2);
      date.dayBeforeYesterdayKey = date.dayBeforeYesterday
        .toISOString()
        .slice(0, 10);

      debugItem["D"] =
        "The problem was in date DISPLAY. Now switched to LUXON." +
        spacesForVisibilityInFirebaseConsole;

      debugItem["D1"] =
        "Using Intl.DateTime, today is " +
        this.insanePieceOfShit(date.todayKey) +
        spacesForVisibilityInFirebaseConsole;
      debugItem["D2"] =
        "Using Luxon, today is " +
        this.formatDateWwwDdMm(date.todayKey) +
        spacesForVisibilityInFirebaseConsole;
      debugItem["D3"] =
        this.formatDateWwwDdMm(date.todayKey) ===
        this.insanePieceOfShit(date.todayKey)
          ? "OK"
          : "OMG! WTF?!?!?!! F**ing Intl.DateTime" +
            spacesForVisibilityInFirebaseConsole;

      const debugKey = new Date() // Date to the millisecond plus 8 random hex digits
        .toISOString()
        .replace("T", "@")
        .replace(/:/g, "-")
        // Actually there is a huge number of these. We will save log overload by writing to a node by the second (not millisecond)
        .split(".")[0];
      //          .replace(".", "_") + Math.floor(Math.random() * 2 ** 32).toString(16);

      if (options.debugLogIt) {
        debugRootRef
          .child("dateFiasco")
          .child(auth.currentUser.uid)
          .child(debugKey)
          .set(debugItem);
      }
      return date;
    },

    dateObjToKey(dateObj) {
      return dateObj.toISOString().slice(0, 10);
    },

    calcDateKeyPlusDeltaDays(key, deltaDays) {
      let dateObj = new Date(key);
      dateObj.setDate(dateObj.getDate() + deltaDays);
      return this.dateObjToKey(dateObj);
    },

    calcDaysBetweenDateKeysInclusive(startKey, endKeyInclusive) {
      const daysDifferentExclusive = Math.round(
        (Date.parse(endKeyInclusive) - Date.parse(startKey)) / 86400000
      );
      return 1 + daysDifferentExclusive;
    },

    calcDateKeyListBetweenDateKeysInclusive(startKey, endKeyInclusive) {
      let iDate = new Date(startKey);
      let dateKey = this.dateObjToKey(iDate);
      let dateKeyList = [];
      while (dateKey <= endKeyInclusive) {
        dateKeyList.push(dateKey);
        iDate.setDate(iDate.getDate() + 1);
        dateKey = this.dateObjToKey(iDate);
      }
      return dateKeyList;
    },

    formatDateWwwDdMm(dateKey) {
      // This uses Luxon because Intl DateTime is shit
      return DateTime.fromISO(dateKey + "T12:00:00Z")
        .toFormat("ccc d LLL")
        .replace(/ /g, "\u00A0"); // &nbsp; to stop date being split by word wrap
    },
    formatDateDdMmYyyy(dateKey) {
      return DateTime.fromISO(dateKey + "T12:00:00Z")
        .toFormat("d LLL yyyy")
        .replace(/ /g, "\u00A0");
    },

    insanePieceOfShit(dateKey) {
      // Don't use this heap of shit: is sometimes showing one day out (some phones! not most):
      const dateFormatterObject = {
        weekday: "short",
        day: "numeric",
        month: "short",
      };
      return Intl.DateTimeFormat("en-GB", dateFormatterObject)
        .format(new Date(dateKey))
        .replace(/ /g, "\u00A0");
    },

    calcTargetDateAndUpToDateness(startDateKey, statusObj, contactObj) {
      // Calculates:
      //     Target Date for the day-by-day data entry
      //     Windows of time needing entry (e.g. weekly)
      //     Whether we are all up to date.
      //     Incidentally returns the current, and last two, date Keys

      // Called every time we come on line, and by a timer every (currently) one hour, and every time they save a day's worth of data
      let date = this.calcTodayYesterdayDayBeforeYesterdayKeys({
        debugLogIt: true,
      }); // Object into which we will inject target date info, and todays date

      // DAY BY DAY data ---------------------------------------------------------------

      let foundAnyMissingDayByDayData = false;
      let iDayChecked = 0;
      let iDateKey = startDateKey;
      let newDate = new Date(); // Dummy value to be overwritten during search

      while (
        iDateKey < date.todayKey &&
        !foundAnyMissingDayByDayData &&
        iDayChecked < 1e5
      ) {
        // Check
        if (
          !statusObj ||
          !statusObj.days ||
          !statusObj.days[iDateKey] ||
          !statusObj.days[iDateKey].saved
        ) {
          foundAnyMissingDayByDayData = true;
          date.targetKey = iDateKey;
        } else {
          // Next
          iDayChecked++;
          newDate = new Date(iDateKey);
          newDate.setTime(newDate.getTime() + 1000 * 60 * 60 * (24 + 2)); // Not just add one to day! Otherwise will get trapped when clocks go forward at Easter
          iDateKey = newDate.toISOString().slice(0, 10);
        }
      }

      if (foundAnyMissingDayByDayData) {
        date.target = new Date(date.targetKey);
        let daysDifferent = Math.round(
          (new Date(date.todayKey) - date.target) / 86400e3
        );
        if (daysDifferent < 30) {
          date.targetDisplayString = this.formatDateWwwDdMm(date.targetKey);
        } else {
          date.targetDisplayString = this.formatDateDdMmYyyy(date.targetKey);
        }

        if (daysDifferent === 1) {
          date.targetDisplayStringWithComment =
            "Yesterday, " + date.targetDisplayString + ":";
        } else if (daysDifferent === 2) {
          date.targetDisplayStringWithComment =
            "The day before yesterday, " + date.targetDisplayString + ":";
        } else {
          date.targetDisplayStringWithComment =
            "On " + date.targetDisplayString + ":";
        }
      }
      // WINDOW (e.g. weekly) data ---------------------------------------------------------

      let windowsDatesObj = {};
      let windowsQuestionsObj = {};

      windowsQuestionsObj =
        (contactObj && contactObj.windows && contactObj.windows.questions) ||
        {};
      if (this.liveOrPractice === "practice") {
        windowsDatesObj = { dummyD1: { endDateKey: date.yesterdayKey } };
      } else {
        // "live" or being run by HQ
        windowsDatesObj =
          (contactObj && contactObj.windows && contactObj.windows.dates) || {};
      }

      // unpack window DATES
      const windowsDatesIdsArray = Object.keys(windowsDatesObj);
      const windowsDatesArray = windowsDatesIdsArray.map((windowsDateKey) => {
        let thing = windowsDatesObj[windowsDateKey];
        Object.assign(thing, { key: windowsDateKey });
        return thing;
      });

      // unpack window QUESTIONS
      const windowsQuestionsIdsArray = Object.keys(windowsQuestionsObj);
      const windowsQuestionsArray = windowsQuestionsIdsArray.map(
        (windowsQuestionKey) => ({
          whenYou: windowsQuestionsObj[windowsQuestionKey],
          key: windowsQuestionKey,
        })
      );

      // Now we know what they should have done, and when they should have reported. Look to see if all past windows have full data.
      let runningStartDateKeyInCaseNotStoredInContacts = startDateKey; // The windows CAN be disjoint but it is more usual to have them end-to-end, so you only have to state the END date (last date of symptom; date of recording is next day). The first date is taken as the day after the last date of the previous window, except for the first window, which starts at the start date.
      //      ### TEST FOR OVERLAPPING  ---- TODO
      let foundAnyMissingWindowData = false;
      let missingWindow = {};

      for (let iWindow = 0; iWindow < windowsDatesIdsArray.length; iWindow++) {
        const windowKey = windowsDatesArray[iWindow].key; // This is the key in the window OBJECT, e.g. fgdf9g6df8g97d6fg98f76g89, not a date key like 2018-10-16
        const endKey = windowsDatesArray[iWindow].endDateKey;
        const startKey =
          windowsDatesArray[iWindow].startDateKey ||
          runningStartDateKeyInCaseNotStoredInContacts;

        windowsQuestionsArray.forEach((questionObj) => {
          const answerObject = ((
            ((statusObj || {}).windows || {})[windowKey] || {}
          ).questions || {})[questionObj.key];
          if (
            !foundAnyMissingWindowData &&
            date.todayKey > endKey &&
            !answerObject
          ) {
            foundAnyMissingWindowData = true;
            missingWindow.windowKey = windowKey;
            missingWindow.question = questionObj;
            missingWindow.endDateKey = windowsDatesArray[iWindow].endDateKey;
            missingWindow.startDateKey = startKey;

            missingWindow.startDateDisplay = this.formatDateWwwDdMm(
              missingWindow.startDateKey
            );
            missingWindow.endDateDisplay = this.formatDateWwwDdMm(
              missingWindow.endDateKey
            );
            missingWindow.durationDaysInclusive =
              this.calcDaysBetweenDateKeysInclusive(
                missingWindow.startDateKey,
                missingWindow.endDateKey
              );
          }

          runningStartDateKeyInCaseNotStoredInContacts =
            this.calcDateKeyPlusDeltaDays(endKey, 1); // for next cycle through loop, for next window
        });
      }
      // OK got the answers for both day-by-day and windows

      if (date.targetKey) {
        // Need to store for HQ the COMPLETED dates, taking into account both daily and weekly requirements for data. Can't just store target because if the participant is off line we don't want HQ to assume they are up to date

        // Option 1. A missing DAILY DATA item
        date.completeToDateKey = this.calcDateKeyPlusDeltaDays(
          date.targetKey,
          -1
        );
      } else if (foundAnyMissingWindowData) {
        // Option 2. A missing WINDOW DATA item
        date.completeToDateKey = this.calcDateKeyPlusDeltaDays(
          missingWindow.endDateKey,
          -1
        );
      } else {
        // Option 3. Nothing missing! Yay!
        date.completeToDateKey = this.calcDateKeyPlusDeltaDays(
          date.todayKey,
          -1
        );
      }

      const returnObj = {
        upToDate: {
          days: !foundAnyMissingDayByDayData,
          windows: !foundAnyMissingWindowData,
          all: !foundAnyMissingDayByDayData && !foundAnyMissingWindowData,
        },
        date, // contains: {        todayKey, yesterdayKey, dayBeforeYesterdayKey,       targetKey,        target,        targetDisplayString,      targetDisplayStringWithComment, completeToDateKey   },
        missingWindow, // either empty or contains: key, startDateKey, endDateKey, startDateDisplay, endDateDisplay, durationDaysInclusive,

        // for display at HQ
      };

      return returnObj;
    },

    writeAndLog: function (ref, value, isSavingOfADayOrWindow = false) {
      // SELF-CONTAINED
      // Presence of isSavingOfADayOrWindow means that we want to test validity of the dataset
      const subPath = ref.toString().substring(ref.root.toString().length);
      const valueToStoreInLog = value === null ? "(cleared)" : value;
      const logItem = {
        at: ServerValueTIMESTAMP,
        by: auth.currentUser.uid,
        to: valueToStoreInLog,
      };
      const newLogItemKey = logRootRef.child(subPath).push();

      //      this.hapticFeedback();

      // These 2 below could be made into simultaneous, and checked server-side - TODO#

      Promise.all([newLogItemKey.set(logItem), ref.set(value)])
        .then(() => {
          this.triggerParticipantScreenRefresh(); // This updates the "refresh" key in the "presence" tag so that everyone viewing this patient's data through this component knows to refresh their screen, solely to show the newly entered data (not to go on to the next data entry etc)

          this.testAndUpdateValidityDaysP(this.date.targetKey).then(() => {
            if (isSavingOfADayOrWindow) {
              this.savedSoPleaseRecalculateMissingDaysAndWindows(
                true /* show spinner */
              );
              this.triggerParticipantScreenRefresh(); // This does it again, now that we have advanced on to the next day etc
            }
          });
        })
        .catch((e) => {
          console.error(
            e,
            "Error in writing (main or log) for path:" +
              subPath +
              "the value:" +
              value
          );
        });
    },

    hapticFeedback: function () {
      // As of 2018, only works on Android not iOS
      if (navigator.vibrate) {
        navigator.vibrate([10]);
      }
    },

    testAndUpdateValidityDaysP: function (targetDateKey) {
      if (targetDateKey) {
        const validity =
          !!this.participant &&
          !!this.participant.statusObj &&
          !!this.participant.statusObj[this.liveOrPractice] &&
          !!this.participant.statusObj[this.liveOrPractice].days &&
          !!this.participant.statusObj[this.liveOrPractice].days[
            targetDateKey
          ] &&
          (this.participant.statusObj[this.liveOrPractice].days[targetDateKey]
            .anginaYesNo === "No" ||
            (this.participant.statusObj[this.liveOrPractice].days[targetDateKey]
              .anginaYesNo === "Yes" &&
              this.participant.statusObj[this.liveOrPractice].days[
                targetDateKey
              ].anginaCount &&
              this.validAnginaSeverity(
                this.participant.statusObj[this.liveOrPractice].days[
                  targetDateKey
                ].anginaSeverity
              )));
        return this.participant.statusRef
          .child(this.liveOrPractice)
          .child("days")
          .child(targetDateKey)
          .child("validClient")
          .set(validity ? true : null);
      } else {
        // If there is no targetDate, i.e. all the day-by-day answers are done, then just return as a resolved promise
        return Promise.resolve();
      }
    },

    savedSoPleaseRecalculateMissingDaysAndWindows: function (
      showSpinnerForAShortTime
    ) {
      // When you KNOW you have updated to go to a new day, on this browser, i.e. you are the person entering it, set showSpinnerForAShortTime to true.
      // When you KNOW you are NOT the person updating the page (or you are reacting secondarily to a REFRESH command you sent to everyone including yourself), don't show the spinner

      // Step 1. Show spinner

      if (showSpinnerForAShortTime) {
        this.symptomEntryProgress.theresMore = true;
        // now force reaction
        this.symptomEntryProgress = JSON.parse(
          JSON.stringify(this.symptomEntryProgress)
        );
      }

      this.$nextTick().then(() => {
        // DOM updated
        // Step 2. After leaving a few milliseconds for the screen to blank with the spinner, calculate the new dates and windows
        setTimeout(() => {
          const targetDateAndUpToDateness = this.calcTargetDateAndUpToDateness(
            this.startDateKeyLiveOrPractice(),
            this.participant.statusObj[this.liveOrPractice],
            this.participant.contactObj || {}
          );

          this.symptomEntryProgress.upToDate =
            targetDateAndUpToDateness.upToDate;
          this.date = targetDateAndUpToDateness.date;
          this.missingWindow = targetDateAndUpToDateness.missingWindow;

          const summary = {
            upToDateClient: targetDateAndUpToDateness.upToDate,
            completeToDateKey:
              targetDateAndUpToDateness.date.completeToDateKey || null,
          };
          // Duplicate writing here so that can be sorted without reading whole Status Object
          this.participant.statusRef.child("progress").update(summary);
          this.participant.presenceRef.child("progress").update(summary);
        }, 500);

        // Step 3 (inside the nextTick promise) Now remove the spinner.
        if (showSpinnerForAShortTime) {
          setTimeout(() => {
            this.symptomEntryProgress.theresMore = false;
            // now force reaction
            this.symptomEntryProgress = JSON.parse(
              JSON.stringify(this.symptomEntryProgress)
            );
          }, 1000);
        }
      });
    },

    practiceAnswersCorrect_givenValidClientAndPractice: function () {
      if (this.date.targetKey === this.date.dayBeforeYesterdayKey) {
        return (
          this.participant.statusObj[this.liveOrPractice].days[
            this.date.targetKey
          ].anginaYesNo === "Yes" &&
          this.participant.statusObj[this.liveOrPractice].days[
            this.date.targetKey
          ].anginaCount === 2 &&
          this.participant.statusObj[this.liveOrPractice].days[
            this.date.targetKey
          ].anginaSeverity >= 200 &&
          this.participant.statusObj[this.liveOrPractice].days[
            this.date.targetKey
          ].anginaSeverity <= 399
        );
      }

      if (this.date.targetKey === this.date.yesterdayKey) {
        return (
          // eslint-disable-next-line
          this.participant.statusObj[this.liveOrPractice].days[
            this.date.targetKey
          ].anginaYesNo === "No"
        );
      }
    },

    showPracticeInputErrorNotificationBriefly(activate) {
      if (activate) {
        const currentErrorInstanceStartTime = new Date().toISOString();
        this.errorWrongPracticeAnswerLast = currentErrorInstanceStartTime;
        this.errorWrongPracticeAnswer = true;
        setTimeout(() => {
          if (
            this.errorWrongPracticeAnswerLast === currentErrorInstanceStartTime
          ) {
            // only hide the error message if this "hide" timeout belongs to the last error message that has been issued. This way, if you have two errors in rapid succession, the HIDE of the FIRST error cannot hide the message of the SECOND error, which causes an awkward flitting of the second error message on and off.
            this.errorWrongPracticeAnswer = false;
          }
        }, 10000);
      } else {
        this.errorWrongPracticeAnswer = false;
      }
    },

    checkAndWriteAnswerToDailyAnginaYesNoQuestion(yesOrNo) {
      this.showPracticeInputErrorNotificationBriefly(false);
      if (
        this.liveOrPractice === "live" || // or in PRACTICE phase, where only particular answers are acceptable
        (this.date.targetKey === this.date.dayBeforeYesterdayKey &&
          yesOrNo === "Yes") ||
        (this.date.targetKey === this.date.yesterdayKey && yesOrNo === "No")
      ) {
        this.writeAndLog(
          this.participant.statusRef
            .child(this.liveOrPractice)
            .child("days")
            .child(this.date.targetKey)
            .child("anginaYesNo"),
          yesOrNo
        );

        this.writeAndLog(
          this.participant.statusRef
            .child(this.liveOrPractice)
            .child("days")
            .child(this.date.targetKey)
            .child("anginaCount"),
          null
        );

        this.writeAndLog(
          this.participant.statusRef
            .child(this.liveOrPractice)
            .child("days")
            .child(this.date.targetKey)
            .child("anginaSeverity"),
          this.sliderInitialInvalidValue
        );

        if (yesOrNo === "No") {
          // If this is a "NO" angina, then go straight ahead and save. Nothing to wait for.
          this.writeAndLog(
            this.participant.statusRef
              .child(this.liveOrPractice)
              .child("days")
              .child(this.date.targetKey)
              .child("saved"),
            true /* actual thing to write */,
            true /* flag to recalc dates */
          );
        }
      } else {
        this.showPracticeInputErrorNotificationBriefly(true);
      }
    },

    checkAndWriteAnswerToFrequencyQuestion(count) {
      this.showPracticeInputErrorNotificationBriefly(false);
      if (
        this.liveOrPractice === "live" ||
        count === 2 /* i.e. for PRACTICE mode, the example case is 2 episodes */
      ) {
        this.writeAndLog(
          this.participant.statusRef
            .child(this.liveOrPractice)
            .child("days")
            .child(this.date.targetKey)
            .child("anginaCount"),
          count
        );
        // Stops "wrong answer" message from persisting if the user quickly re-answers correctly
      } else {
        this.showPracticeInputErrorNotificationBriefly(true);
      }
    },

    checkAndWriteAnswerToSeverityQuestion(sliderValue) {
      this.showPracticeInputErrorNotificationBriefly(false);
      if (
        this.liveOrPractice === "live" ||
        (sliderValue >= 200 &&
          sliderValue <=
            399) /* i.e. for PRACTICE mode, you need to be in the MODERATE zone */
      ) {
        this.writeAndLog(
          this.participant.statusRef
            .child(this.liveOrPractice)
            .child("days")
            .child(this.date.targetKey)
            .child("anginaSeverity"),
          sliderValue
        );

        this.writeAndLog(
          this.participant.statusRef
            .child(this.liveOrPractice)
            .child("days")
            .child(this.date.targetKey)
            .child("saved"),
          true /* value being written */,
          true /* says this is the saving a whole day's data, so triggering a recalc of target date and weeks */
        );
        this.errorWrongPracticeAnswer = false; // Stops "wrong answer" message from persisting if the user quickly re-answers correctly
      } else {
        this.showPracticeInputErrorNotificationBriefly(true);
      }
    },

    checkAndWriteAnswerToWindowQuestion(answer) {
      this.showPracticeInputErrorNotificationBriefly(false);
      if (
        this.liveOrPractice === "live" ||
        (this.missingWindow.question.key === "activity_001" &&
          answer === "No") ||
        (this.missingWindow.question.key === "activity_002" && answer === "Yes")
      ) {
        this.writeAndLog(
          this.participant.statusRef
            .child(this.liveOrPractice)
            .child("windows")
            .child(this.missingWindow.windowKey)
            .child("questions")
            .child(this.missingWindow.question.key)
            .child("anginaYesNo"),
          answer,
          true
        );
      } else {
        this.showPracticeInputErrorNotificationBriefly(true);
      }
    },
  } /* closing brace for 'methods' */,
}; /* closing brace for export default */
</script>

<style>
/* Vue Transitions */

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  max-height: 0;
}

.slide-fade-enter-active {
  transition: opacity 2s ease-in-out, max-height 1s linear;
}

.slide-fade-leave-active {
  transition: opacity 0.5s ease-in-out, max-height 1s linear;
}

.slide-fade-enter-to,
.slide-fade-leave {
  opacity: 1;
  max-height: 100vh;
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  margin-top: -12px;
  height: 32px;
  width: 32px;
  background: #006eaf;
  border: none;
}

input[type="range"]::-webkit-slider-runnable-track {
  height: 1px;
  cursor: pointer;
  background: none;
}

.zero-width-arrow-up {
  /* https://css-tricks.com/snippets/css/css-triangle/ */
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 20px solid #006eaf;
}
</style>


// WEBPACK FOOTER //
// src/components/SymptomEntry.vue